import * as React from 'react';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';

import { Paper, Typography, LinearProgress } from '@material-ui/core';

import { NumberConvert, NumberCompareVP, NumberLessBRL } from '../../../../services';
import { QueryFilter, QUERY_FILTER_PUBLISHER } from 'src/component/shared';
import { GetCacheIfExists, SetDataToSession, HasNoFilterAppliedPublisher } from '../../../shared/cache/Cache';

// tslint:disable-next-line:no-empty-interface
export interface IPublisherVolumeProps {
}

// tslint:disable-next-line:no-empty-interface
export interface IPublisherVolumeState {
    customFilter: {
        isChart: boolean
    },

}
const PUBLISHER_VOLUME = gql`
query publisherVolume($customFilter:  PublisherCustomFilter) {
    publisherVolume(publisherCustomFilter: $customFilter) {
        current_year,
		last_year
  }
}
`;

export class PublisherVolume extends React.Component<IPublisherVolumeProps, IPublisherVolumeState> {
    constructor(props: IPublisherVolumeProps) {
        super(props);
        this.state = {
            customFilter: {
                isChart: true,
            },
        }
    }

    public render() {
        const jsonFilter = {
            "customFilter": {
                "isChart": this.state.customFilter.isChart,
            }
        };

        return (<Query query={QUERY_FILTER_PUBLISHER} notifyOnNetworkStatusChange={true}  >
            {({ loading: loadingC, error: errorC, data: cache, client: clientC}) => {

                let dataCache = GetCacheIfExists('publisher-data');
                const hasNoFilterAppliedPublisher = HasNoFilterAppliedPublisher(clientC);

                if( hasNoFilterAppliedPublisher && dataCache != null && dataCache.publisherVolume != null ) {
                    return this.dataToRend(dataCache, false);
                } else {
                    return (
                        <Query query={PUBLISHER_VOLUME} variables={QueryFilter.getFilterPublisher(clientC, jsonFilter, ['endDate', 'initialDate'])}>
                            {({ loading, error, data, client }) => {

                                if ( hasNoFilterAppliedPublisher && data != null && data.publisherVolume != null ) {
                                    if(dataCache != null && dataCache !== undefined) {
                                        dataCache.publisherVolume = data.publisherVolume;
                                    } else {
                                        dataCache = data;
                                    }
                                    SetDataToSession('publisher-data', dataCache);
                                }

                                return this.dataToRend(data,loading);
                            }}
                        </Query>
                    );
                }

            }}
        </Query>)
    }

    /**
     * Método utilizado para renderizar as informações do card
     * Foi destacado do restante do código para que seja reutilizado nas requisições de cache e do graphql
     */
    private dataToRend (data:any, loading:any) {
        /**
         * Caso a consulta não retorne o faturamento do ano anterior, nem o faturamento atual
         *      Não será calculado o percentual de divergência e a informação não será apresentada ao cliente
         */
        let percetDiference = null;
        if(data != null && data.publisherVolume != null && data.publisherVolume.length > 0 && 
            data.publisherVolume[0].last_year != null && parseFloat(data.publisherVolume[0].last_year).toFixed(0) !== "0" &&
            data.publisherVolume[0].current_year != null && parseFloat(data.publisherVolume[0].current_year).toFixed(0) !== "0") {
            percetDiference = NumberCompareVP(
                NumberConvert(data.publisherVolume[0].current_year),
                NumberConvert(data.publisherVolume[0].last_year)
            );
        }

        return (
            <Paper className="publisher-sale-block panel-block">
                <Typography variant="headline" className="panel-title" component="title">
                    Volume
                </Typography>
                
                {loading && <LinearProgress />}
                <Typography component="p" className="big-number">
                    {data && data.publisherVolume && NumberLessBRL(data.publisherVolume[0].current_year)}
                </Typography>

                {data && data.publisherVolume &&
                    (
                        percetDiference == null ? (
                            <Typography component="p" className="comparative transparent">
                                -
                            </Typography>
                        ) : percetDiference >= 0 ? (
                            <Typography component="p" className="comparative">
                                <span className="content-positive content-label" >
                                    {
                                        percetDiference.toFixed(1).replace(/\./g, ',')
                                    }% ano anterior
                                </span>
                            </Typography>
                        ) : (
                            <Typography component="p" className="comparative">
                                <span className="content-negative content-label" >
                                        {
                                        percetDiference.toFixed(1).replace(/\./g, ',')
                                    }% ano anterior
                                </span>
                            </Typography>
                        )
                    )
                }
            </Paper>
        )
    }
}



// WEBPACK FOOTER //
// ./src/component/publisher/sale/volume/PublisherVolume.tsx